export default __webpack_public_path__ + "static/media/ic_camera_add.e91d4eb0.svg";